import React from 'react'
import { dayjs } from '@mobi/utils/date'
import { CountdownBadge } from '@mobi/component-library/Feedback/CountdownBadge'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'

export const CountdownStatus: React.FC<{
  ticket: BetLoopKambiShareCoupon
}> = ({ ticket }) => {
  const countdownDate = getCountdownDate(ticket)
  return (
    countdownDate && <CountdownBadge badgeSize='S' advertisedStartTime={new Date(countdownDate)} />
  )
}

// =======
// Helpers
// =======

function getCountdownDate(ticket: BetLoopKambiShareCoupon): string {
  const currentTime = dayjs()
  const allStartTimes = ticket.events.map(event => event.eventStartDate)
  const timesFromNow = allStartTimes.map(time => {
    const diff = currentTime.diff(dayjs(time))
    // Allow time if within 2min
    if (diff < 1000 * 60 * 2) {
      return diff
    }
    return -Infinity
  })
  const closestTime = Math.max(...timesFromNow)
  const indexOfClosest = timesFromNow.findIndex(time => time === closestTime)
  if (indexOfClosest === -1) {
    return dayjs(allStartTimes[0]).toISOString()
  }
  return dayjs(allStartTimes[indexOfClosest]).toISOString()
}
